<template>
  <el-row>
    <slot></slot>
    <transition name="el-fade-in">
      <router-view></router-view>
    </transition>
  </el-row>
</template>
<script>
export default {
  props: {
    nav: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
   
    };
  },
  created() {
    
  },
  methods: {
    

  }
};
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/page/page-main.vue